// extracted by mini-css-extract-plugin
export default {"skeleton":"MeterConsumptionSection_skeleton__8swXr","shimmer":"MeterConsumptionSection_shimmer__bZs2V"};